export default __webpack_public_path__ + "static/media/ibrahim4.1a6f7e06.jpeg";